// /*eslint-disable*/

// import React, { useEffect } from "react";
// import "../../Assests/Globalcss/stylesheet.css";
// import logo from "../../Assests/Globalimages/nav-icon (2).png";
// import icon1 from "../../Assests/Globalimages/nav-icon (1).png";
// import icon3 from "../../Assests/Globalimages/nav-icon (3).png";
// import { useNavigate, NavLink, useLocation } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import ProfileCircle from "./ProfileCircel";
// import { useState } from "react";
// import { fetchUser } from "../../Redux/User/userSlice";
// import { getCartItems_db } from "../../Redux/db_Cart/db_cartSlice";

// const index = () => {
//   const navigate = useNavigate();
//   const cartItems = useSelector((state) => state.cart.cartItems);
//   const favorites = useSelector((state) => state.favorites.items); // Assuming favorites are stored in Redux
//   const dispatch = useDispatch();
//   const [search, setSearch] = useState("");
//   const { pathname } = useLocation();
//   let token = localStorage.getItem("token");
  

// useEffect(()=>{
//   dispatch(fetchUser());
//   dispatch(getCartItems_db())
// },[])

// const {dbCartItems} = useSelector((state)=> state.db_cart);
// console.log(dbCartItems , "Db cart Items")

// const handleCancelSearch= ()=>{
//   setSearch("")
//   if(pathname == '/shop'){
//     navigate("/shop", { state: { search: '' } });

//   }

// }

//   const handleSearch = () => {
//     navigate("/shop", { state: { search: search } });
//   };

//   // useEffect(()=>{
//   //   if(search == ''){
//   //     if(pathname == '/shop'){
//   //       navigate('/shop')
//   //     }
//   //   }

//   // }, [search])

//   let items = !token ? cartItems : dbCartItems;

//   return (
//     <div>
//       <nav class="navbar navbar-expand-lg fixed-top main-navbar About-navbar">
//         <div class="container">
//           <a class="navbar-brand" href="/">
//             <img src={logo} alt="" />
//           </a>
//           {/* <!-- Corrected Toggler Button --> */}
//           <button
//             class="navbar-toggler"
//             type="button"
//             data-bs-toggle="collapse"
//             data-bs-target="#navbarText"
//             aria-controls="navbarText"
//             aria-expanded="false"
//             aria-label="Toggle navigation"
//           >
//             <span class="navbar-toggler-icon"></span>
//           </button>

//           <div
//             class="collapse navbar-collapse justify-content-end gap-5 navbar_text"
//             id="navbarText"
//           >
//             <ul class="navbar-nav d-flex gap-4">
//               <li class="nav-item dropdown ">
//                 {/* <a class="nav-link" onClick={() => navigate("/")}>
//                   Home
//                 </a> */}
//                 <NavLink className="nav-link" to="/">
//                   Home
//                 </NavLink>
//               </li>

//               <li class="nav-item">
//                 {/* <a class="nav-link" onClick={() => navigate("/Shop")}>
//                   Shop
//                 </a> */}
//                 <NavLink className="nav-link" to="/Shop">
//                   Shop
//                 </NavLink>
//               </li>
//               <li class="nav-item">
//                 {/* <a class="nav-link" onClick={() => navigate("/AboutUS")}>
//                   About
//                 </a> */}
//                 <NavLink className="nav-link" to="/AboutUS">
//                   About
//                 </NavLink>
//               </li>
//               <li class="nav-item">
//                 {/* <a class="nav-link" onClick={() => navigate("/ContactUs")}>
//                   Contact Us
//                 </a> */}
//                 <NavLink className="nav-link" to="/ContactUs">
//                   Contact Us
//                 </NavLink>
//               </li>
//             </ul>
//             <span class="navbar-text nav-icon">
//             <div className="nav_inp" style={{ position: "relative", display: "flex", alignItems: "center" }}>
//               <input
//                 onChange={(e) => setSearch(e.target.value)}
//                 value={search}
//                 type="text"
//                 placeholder="What are you looking for?"
//                 onKeyDown={(e) => e.key === "Enter" && handleSearch()} // Search on Enter key
//               />

//               {search && (
//                 <i
//                   onClick={() => handleCancelSearch()}
//                   className="fa-solid fa-xmark"
//                   style={{
//                     position: "absolute",
//                     right: "35px",
//                     cursor: "pointer",
//                     color: "red",
//                     fontSize: "16px",
//                   }}
//                 ></i>
//               )}

//               <i
//                 onClick={handleSearch}
//                 className="fa-solid fa-magnifying-glass"
//                 style={{
//                   position: "absolute",
//                   right: "10px",
//                   cursor: "pointer",
//                   fontSize: "16px",
//                   color: "#333",
//                 }}
//               ></i>
//             </div>



//               {localStorage.getItem("token") && <ProfileCircle />}
//               {!localStorage.getItem("token") && (
//                 <button
//                   onClick={() => navigate("/signin")}
//                   className="btn btn-dark d-flex align-items-center"
//                 >
//                   <i className="fas fa-user-plus me-2"></i> Login
//                 </button>
//               )}
//                   <div className="nav-icons">
//   {/* Favorites Icon */}
//   <div style={{ position: "relative", display: "inline-block" }}>
//     <img
//       src={icon1}
//       alt="Favorites"
//       onClick={() => navigate('/favourites')}
//       style={{ cursor: "pointer", width: "24px", height: "24px" }}
//     />
//     {favorites?.length > 0 && (
//       <span
//         style={{
//           position: "absolute",
//           top: "-8px",
//           right: "-8px",
//           backgroundColor: "red",
//           color: "white",
//           borderRadius: "50%",
//           width: "18px",
//           height: "18px",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           fontSize: "12px",
//           fontWeight: "bold",
//         }}
//       >
//         {favorites.length}
//       </span>
//     )}
//   </div>

//   {/* Cart Icon */}
//   <div style={{ position: "relative", display: "inline-block", marginLeft: "10px" }}>
//     <img
//       src={icon3}
//       alt="Cart"
//       onClick={() => navigate("/cart")}
//       style={{ cursor: "pointer", width: "24px", height: "24px" }}
//     />
//     {items?.length > 0 && (
//       <span
//         style={{
//           position: "absolute",
//           top: "-8px",
//           right: "-8px",
//           backgroundColor: "green",
//           color: "white",
//           borderRadius: "50%",
//           width: "18px",
//           height: "18px",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           fontSize: "12px",
//           fontWeight: "bold",
//         }}
//       >
//         {items.length}
//       </span>
//     )}
//   </div>
// </div>
//             </span>
//           </div>
//         </div>
//       </nav>
//     </div>
//   );
// };

// export default index;
/*eslint-disable*/

import React, { useEffect } from "react";
import "../../Assests/Globalcss/stylesheet.css";
import logo from "../../Assests/Globalimages/nav-icon (2).png";
import icon1 from "../../Assests/Globalimages/nav-icon (1).png";
import icon3 from "../../Assests/Globalimages/nav-icon (3).png";
import { useNavigate, NavLink, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import ProfileCircle from "./ProfileCircel";
import { useState } from "react";
import { fetchUser } from "../../Redux/User/userSlice";
import { getCartItems_db } from "../../Redux/db_Cart/db_cartSlice";

const index = () => {
  const navigate = useNavigate();
  const cartItems = useSelector((state) => state.cart.cartItems);
  const favorites = useSelector((state) => state.favorites.items); // Assuming favorites are stored in Redux
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const { pathname } = useLocation();
  let token = localStorage.getItem("token");
  const {dbCartItems} = useSelector((state)=> state.db_cart);
console.log(dbCartItems , "Db cart Items")

  useEffect(() => {
    dispatch(fetchUser());
    dispatch(getCartItems_db());
  }, []);

  let items = !token ? cartItems : dbCartItems;

  const handleCancelSearch = () => {
    setSearch("");
    if (pathname === "/shop") {
      navigate("/shop", { state: { search: "" } });
    }
  };

  const handleSearch = () => {
    navigate("/shop", { state: { search: search } });
  };

  // Function to close mobile menu
  const closeMobileMenu = () => {
    const navbar = document.getElementById("navbarText");
    if (navbar.classList.contains("show")) {
      navbar.classList.remove("show");
    }
  };

  return (
    <div>
      <nav className="navbar navbar-expand-lg fixed-top main-navbar About-navbar">
        <div className="container">
          <a className="navbar-brand" href="/">
            <img src={logo} alt="Logo" />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarText"
            aria-controls="navbarText"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className="collapse navbar-collapse justify-content-end gap-5 navbar_text"
            id="navbarText"
          >
            <ul className="navbar-nav d-flex gap-4">
              <li className="nav-item">
                <NavLink className="nav-link" to="/" onClick={closeMobileMenu}>
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/Shop" onClick={closeMobileMenu}>
                  Shop
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/AboutUS" onClick={closeMobileMenu}>
                  About
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/ContactUs" onClick={closeMobileMenu}>
                  Contact Us
                </NavLink>
              </li>
            </ul>

            <span className="navbar-text nav-icon">
              <div className="nav_inp" style={{ position: "relative", display: "flex", alignItems: "center" }}>
                <input
                  onChange={(e) => setSearch(e.target.value)}
                  value={search}
                  type="text"
                  placeholder="What are you looking for?"
                  onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                />

                {search && (
                  <i
                    onClick={handleCancelSearch}
                    className="fa-solid fa-xmark"
                    style={{
                      position: "absolute",
                      right: "35px",
                      cursor: "pointer",
                      color: "red",
                      fontSize: "16px",
                    }}
                  ></i>
                )}

                <i
                  onClick={handleSearch}
                  className="fa-solid fa-magnifying-glass"
                  style={{
                    position: "absolute",
                    right: "10px",
                    cursor: "pointer",
                    fontSize: "16px",
                    color: "#333",
                  }}
                ></i>
              </div>

              {localStorage.getItem("token") && <ProfileCircle />}
             {/* Login Button and Icons */}
<div className="d-flex flex-row align-items-center gap-3 mt-2 mt-lg-0">
  {!localStorage.getItem("token") && (
    <button
      onClick={() => {
        navigate("/signin");
        closeMobileMenu();
      }}
      className="btn btn-dark d-flex align-items-center"
    >
      <i className="fas fa-user-plus me-2"></i> Login
    </button>
  )}

  <div className="d-flex flex-row gap-3">
    {/* Favorites Icon */}
    <div style={{ position: "relative", display: "inline-block" }}>
      <img
        src={icon1}
        alt="Favorites"
        onClick={() => {
          navigate("/favourites");
          closeMobileMenu();
        }}
        style={{ cursor: "pointer", width: "24px", height: "24px" }}
      />
      {favorites?.length > 0 && (
        <span className="badge bg-danger position-absolute top-0 start-100 translate-middle">
          {favorites.length}
        </span>
      )}
    </div>

    {/* Cart Icon */}
    <div style={{ position: "relative", display: "inline-block" }}>
      <img
        src={icon3}
        alt="Cart"
        onClick={() => {
          navigate("/cart");
          closeMobileMenu();
        }}
        style={{ cursor: "pointer", width: "24px", height: "24px" }}
      />
      {items?.length > 0 && (
        <span className="badge bg-success position-absolute top-0 start-100 translate-middle">
          {items.length}
        </span>
      )}
    </div>
  </div>
</div>

            </span>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default index;
